import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import { inboxItemSchema } from "./inbox.js";
import { signalTextEnvelopeSchema } from "../protocol/envelope.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-message-search.ts
const spaceMessageSearchQuerySchema = z$1.strictObject({
	q: z$1.string().trim().min(1).max(200).refine((value) => [...value].length >= 1, "Enter at least 1 character."),
	cursor: z$1.string().regex(/^[1-9]\d*$/).refine((value) => Number.isSafeInteger(Number(value))).optional(),
	limit: z$1.coerce.number().int().min(1).max(50).default(30)
});
const spaceMessageSearchResponseSchema = z$1.strictObject({
	signals: z$1.array(signalTextEnvelopeSchema).max(50),
	nextCursor: z$1.string().nullable(),
	searchIndexing: z$1.boolean(),
	threadRoots: z$1.record(z$1.string(), z$1.string())
});
const messageSearchCursorSchema = z$1.strictObject({
	activitiesDone: z$1.boolean().default(false),
	activityBefore: z$1.number().int().positive().optional(),
	afterSpaceId: z$1.string().max(256),
	pending: z$1.array(z$1.strictObject({
		spaceId: z$1.string().min(1).max(256),
		cursor: spaceMessageSearchQuerySchema.shape.cursor
	})).max(4)
});
const validateMessageSearchLength = (input, context) => {
	if (!input.spaceId && [...input.q].length < 3) context.addIssue({
		code: "custom",
		message: "Enter at least 3 characters for workspace search.",
		path: ["q"]
	});
};
const messageSearchQuerySchema = z$1.strictObject({
	q: spaceMessageSearchQuerySchema.shape.q,
	cursor: z$1.string().max(4096).optional(),
	spaceId: z$1.string().min(1).max(256).optional(),
	scope: z$1.enum(["messages", "inbox"]).default("messages")
}).superRefine(validateMessageSearchLength);
const messageSearchRpcInputSchema = messageSearchQuerySchema.safeExtend({ context: openMeldRequestContextSchema });
const messageSearchResponseSchema = z$1.strictObject({
	activities: z$1.array(inboxItemSchema).max(30),
	matches: z$1.array(z$1.strictObject({
		signal: signalTextEnvelopeSchema,
		threadRootSignalId: z$1.string().nullable(),
		spaceName: z$1.string().nullable(),
		directMessage: z$1.boolean(),
		centerAgent: z$1.boolean(),
		inboxItemId: z$1.string().optional()
	})).max(120),
	nextCursor: z$1.string().nullable(),
	indexing: z$1.boolean()
});
//#endregion
export { messageSearchCursorSchema, messageSearchQuerySchema, messageSearchResponseSchema, messageSearchRpcInputSchema, spaceMessageSearchQuerySchema, spaceMessageSearchResponseSchema };

//# sourceMappingURL=space-message-search.js.map